import { create } from "zustand";
import { persist } from "zustand/middleware";
import { commonApi } from "@/api/common";
import { decodeRSA } from "@/utils/rsa";
// 默认公司（统一管理）
const defaultCompany = {
    id: "0",
    companyName: "全部",
    companyCode: "0",
    companyShortName: "全部",
};
// 3. 创建全局 Store
export const useCompanyStore = create()(persist((set, get) => ({
    // 初始值
    companyTree: [defaultCompany],
    company: defaultCompany,
    loading: false,
    // 设置选中公司
    setCompany: (company) => set({ company }),
    // 设置公司树
    setCompanyTree: (companyTree) => set({ companyTree }),
    // 请求公司树
    fetchCompanyTree: async () => {
        set({ loading: true });
        try {
            const companyTreeData = await commonApi.companyTree();
            const companyTree = [defaultCompany];
            companyTreeData.data.forEach((item) => {
                companyTree.push({
                    id: item.id,
                    companyName: decodeRSA(item.companyName),
                    companyCode: item.companyCode,
                    companyShortName: decodeRSA(item.companyShortName),
                });
            });
            set({ companyTree });
        }
        catch (err) {
            console.error("获取公司树失败", err);
        }
        finally {
            set({ loading: false });
        }
    },
    // ################################################################
    // 🔥 🔥 🔥 登录重置公司（你要的功能）
    // ################################################################
    resetCompany: () => {
        set({
            company: defaultCompany,
            companyTree: [defaultCompany],
        });
        // 清除本地缓存
        localStorage.removeItem("company-store");
    },
}), 
// 持久化配置
{
    name: "company-store",
    partialize: (state) => ({
        companyTree: state.companyTree,
        company: state.company,
    }),
}));
